import { StripeElementLocale } from "@stripe/stripe-js/";

const APPLICATION_LOCALES = [
  "de-de",
  "en-us",
  "es-es",
  "fr-fr",
  "ja-jp",
  "ko-kr",
  "zh-tw",
  "th-th",
  "id-id",
  "pt-br",
  "zh-cn"
] as const;

type ApplicationLocale = typeof APPLICATION_LOCALES[number];

const PAYPAL_LOCALE_MAP = {
  "de-de": "de_DE",
  "en-us": "en_US",
  "es-es": "es_ES",
  "fr-fr": "fr_FR",
  "ja-jp": "ja_JP",
  "ko-kr": "ko_KR",
  "zh-tw": "zh_TW",
  "th-th": "th_TH",
  "id-id": "id_ID",
  "pt-br": "pt_BR",
  "zh-cn": "en_US"
} as any;

// https://developers.google.com/recaptcha/docs/language?hl=ja
const RE_CAPTCHA_MAP = {
  "de-de": "de",
  "en-us": "en",
  "es-es": "es",
  "fr-fr": "fr",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "zh-tw": "zh-TW",
  "th-th": "th",
  "id-id": "id",
  "pt-br": "pt-BR",
  "zh-cn": "en"
};

const STRIPE_LOCALE_MAP = {
  "ja-jp": "ja",
  "de-de": "de",
  "en-us": "en",
  "es-es": "es",
  "fr-fr": "fr",
  "ko-kr": "ko",
  "zh-tw": "zh-TW",
  "zh-cn": "zh",
  "th-th": "th",
  "id-id": "id",
  "pt-br": "pt-BR"
};

export default new (class Locale {
  getLocale(): ApplicationLocale {
    const matchedString = window.location.pathname.split("/");
    if (APPLICATION_LOCALES.includes(matchedString[1] as ApplicationLocale)) {
      return matchedString[1] as ApplicationLocale;
    }

    return "en-us";
  }

  // Paypal iframe の言語を切り替えるには Paypal がサポートしているロケールコードを指定する必要がある
  // 参照 : https://developer.paypal.com/api/rest/reference/locale-codes/
  getPaypalLocale(locale: ApplicationLocale): string {
    if (APPLICATION_LOCALES.includes(locale)) {
      return PAYPAL_LOCALE_MAP[locale];
    }

    return PAYPAL_LOCALE_MAP["en-us"];
  }

  getReCaptchaLocale(): string {
    const locale = this.getLocale() as ApplicationLocale;
    return RE_CAPTCHA_MAP[locale];
  }

  getStripeLocale(): StripeElementLocale {
    return STRIPE_LOCALE_MAP[this.getLocale()] as StripeElementLocale;
  }
})();
